"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoubleBetAction = void 0;
class DoubleBetAction {
    execute(playerManager, _blackjackState, instant) {
        playerManager.setDoubleBet(playerManager.currentPlayer, instant);
    }
}
exports.DoubleBetAction = DoubleBetAction;
